<select
  [formControl]="control"
  [class]="computedCssClass"
  [required]="required"
  [disabled]="disabled"
  (change)="onSelectionChange($event)"
  class="form-select">
  <option value="" [selected]="!control.value">{{ placeholder }}</option>
  <option
    *ngFor="let state of states"
    [value]="state"
    [selected]="control.value === state">
    {{ state }}
  </option>
</select>
